import { AudioManager } from './utilities/AudioManager';

export class SuperBonusMultiplier extends Phaser.GameObjects.Container {
  private superBonus;
  private superbonusIndex;
  private superBonusMulitpier;

  private readonly screenWidth;
  private readonly screenHeight;
  private winningNumbers: any;
  controlPanel: any;

  constructor(scene, screenWidth, screenHeight, drawResult) {
    super(scene);

    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    if (!drawResult || drawResult.length !== 3) {
      this.showErrorMessage('Invalid draw result');
      return;
    }

    this.superbonusIndex = drawResult[2];
    this.winningNumbers = drawResult.slice(0, 2);
    this.createBody();
  }

  showErrorMessage(message) {
    console.log(message);
  }

  createBody() {
    this.addCountdown();
  }

  addCountdown() {
    this.superBonusMulitpier = this.scene.add.image(this.screenWidth / 2, this.screenHeight * 0.43, 'superBonus').setScale(0.7);

    this.startWheelRotation();
  }

  public startWheelRotation = () => {
    const bg = this.scene.add.sprite(this.screenWidth * 0.5, this.screenHeight * 0.9, 'spin1').setScale(1.0);

    const bgFrames = [];
    for (let j = 1; j < 9; j++) {
      for (let i = 1; i < 6; i++) {
        if (j === 8 && i === this.superbonusIndex + 1) {
          break;
        }
        // @ts-ignore
        bgFrames.push({ key: 'spin' + i });
      }
    }
    bg.on('animationcomplete', this.highlightMultiplier);

    bg.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      this.scene.tweens.add({
        targets: bg,
        alpha: 0,
        duration: 1000
      });
    });

    this.scene.anims.create({
      key: 'spin',
      frames: bgFrames,
      frameRate: 6,
      yoyo: false
    });
    this.superBonusMulitpier.setVisible(true);

    bg.play('spin');
  };

  public highlightMultiplier = () => {
    switch (this.superbonusIndex) {
      case 1: {
        this.superBonus = this.getSuperBonusTarget(this.screenWidth / 9.88, this.screenHeight * 0.823);
        this.superBonus.setAngle(-90);
        this.rotateFinalMultiplier(this.superBonus, this.screenWidth / 1.9, this.screenHeight / 1.25, -90, 72);

        break;
      }
      case 2: {
        this.superBonus = this.getSuperBonusTarget(this.screenWidth / 4.24, this.screenHeight * 0.715);
        this.rotateFinalMultiplier(this.superBonus, this.screenWidth / 2.1, this.screenHeight / 1.25, 0, 37);
        break;
      }
      case 3: {
        this.superBonus = this.getSuperBonusTarget(this.screenWidth / 2, this.screenHeight * 0.675);
        this.rotateFinalMultiplier(this.superBonus, this.screenWidth / 2, this.screenHeight / 1.25, 0, 0);
        break;
      }
      case 4: {
        this.superBonus = this.getSuperBonusTarget(this.screenWidth / 1.31, this.screenHeight * 0.715);
        this.rotateFinalMultiplier(this.superBonus, this.screenWidth / 1.95, this.screenHeight / 1.25, 0, -35);
        break;
      }
      case 5: {
        this.superBonus = this.getSuperBonusTarget(this.screenWidth / 1.12, this.screenHeight * 0.823);
        this.superBonus.setAngle(90);
        this.rotateFinalMultiplier(this.superBonus, this.screenWidth / 2.2, this.screenHeight / 1.25, 90, -70);
        break;
      }
      default: {
        break;
      }
    }
  };

  getSuperBonusTarget = (xPos, yPos) => {
    const superBonus = this.scene.add.sprite(xPos, yPos, 'Bonus' + this.superbonusIndex).setScale(1);
    return superBonus;
  };

  rotateFinalMultiplier = (target, xPos, yPos, startAngle, endAngle) => {
    this.scene.tweens.add({
      targets: target,
      x: xPos,
      y: yPos,
      duration: 1000,
      ease: 'Sine.easeOut',
      completeDelay: 3000,
      yoyo: false,
      scale: {
        start: 1,
        to: 1.15
      },
      angle: {
        start: startAngle,
        to: endAngle
      },
      onComplete: () => {
        this.scene.add.image(this.screenWidth / 2, this.screenHeight * 0.49, 'winningNumbers').setScale(1.2);
        this.scene.add.image(this.screenWidth / 2 - 110, this.screenHeight * 0.59, `greennumberball_${this.winningNumbers[0]}`);
        this.scene.add.image(this.screenWidth / 2 + 110, this.screenHeight * 0.59, `greennumberball_${this.winningNumbers[1]}`);
        this.scene.add.image(this.screenWidth / 2, this.screenHeight * 0.69, 'finalSuperBonus');
        this.scene.events.emit('multiplierNumberAnimationEnded');
      }
    });
    AudioManager.getInstance().playSoundEffect(this.scene, 'bonus_win');
  };

  updateReplayButton() {
    this.controlPanel.button.setTexture('replay');
  }
}
